var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content-wrap"}},[_c('afooter',{staticClass:"a-footer"},[_c('div',{staticClass:"text-center p-4"},[_vm._v("\n     Copyright © 2020-2023\n     "),_c('a',{staticClass:"text-reset fw-bold",staticStyle:{"text-decoration":"none"},attrs:{"href":"https://encodingai.com"}},[_vm._v("Encoding A.I.")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }